import React, { useState } from 'react';
import { Send, Sliders, ShieldCheck, LayoutDashboard } from 'lucide-react';

import FinanceiroTrocoFormulario from './FinanceiroTrocoFormulario';
import FinanceiroTrocoControle from './FinanceiroTrocoControle';
import FinanceiroTrocoConferencia from './FinanceiroTrocoConferencia';
import FinanceiroTrocoSaldos from './FinanceiroTrocoSaldos';

// ============================================================================
// Sub-hub do Troco — QUATRO telas (reformulação de 2026-07-30)
// ============================================================================
//   Envio → Controle → Conferência → Saldos
//
// Eram SETE abas. A Conferência fundiu quatro delas (Depósito, Confirmação de
// Depósito, Lançar Acerto e Conferência PDV) porque as quatro tratavam do mesmo
// assunto — o depósito — em pedaços que obrigavam o operador a saltar de tela
// para completar um raciocínio só.
//
// O fluxo agora se lê na ordem em que o dinheiro anda:
//   Envio        → o escritório manda o troco para a loja
//   Controle     → o relatório de tudo que aconteceu (monitoramento)
//   Conferência  → o depósito: propor, lançar, confirmar (ação)
//   Saldos       → quanto cada loja tem parado, com extrato
const FinanceiroTroco = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userRole = user?.perfil || '';

    // Admin tem bypass em tudo. Gerente Plantão tem o MESMO acesso do Gerente.
    // ⚠️ `Operacional` (28/09/2026): acesso total ao Financeiro (nível Admin).
    const podeFinanceiro = ['Admin', 'Financeiro', 'Operacional'].includes(userRole);
    // Gerente e Gerente Plantão NÃO veem o painel consolidado de Saldos (visão
    // da rede toda) — a operação deles é a própria loja.
    const podeSaldos = !['Gerente', 'Gerente Plantao'].includes(userRole);

    const abas = [
        podeFinanceiro && { id: 'enviar', label: 'Envio de Troco', Icone: Send },
        { id: 'controle', label: 'Controle', Icone: Sliders },
        { id: 'conferencia', label: 'Conferência', Icone: ShieldCheck },
        podeSaldos && { id: 'saldos', label: 'Saldos', Icone: LayoutDashboard },
    ].filter(Boolean);

    // Visão inicial: Saldos quando disponível; senão a Conferência, que é onde o
    // gerente tem trabalho a fazer.
    const [activeSubTab, setActiveSubTab] = useState(podeSaldos ? 'saldos' : 'conferencia');

    const renderSubTab = () => {
        switch (activeSubTab) {
            case 'enviar': return <FinanceiroTrocoFormulario />;
            case 'controle': return <FinanceiroTrocoControle />;
            case 'conferencia': return <FinanceiroTrocoConferencia />;
            case 'saldos': return <FinanceiroTrocoSaldos />;
            default: return <FinanceiroTrocoControle />;
        }
    };

    const tabStyle = (isActive) => ({
        display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px',
        backgroundColor: isActive ? '#e0f2f1' : 'transparent',
        color: isActive ? '#16a39c' : '#64748b',
        border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer',
        transition: 'all 0.2s', fontSize: '14px'
    });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', borderBottom: '1px solid #e2e8f0', paddingBottom: '16px' }}>
                {abas.map(({ id, label, Icone }) => (
                    <button key={id} onClick={() => setActiveSubTab(id)} style={tabStyle(activeSubTab === id)}>
                        <Icone size={18} /> {label}
                    </button>
                ))}
            </div>

            <div style={{ paddingTop: '8px' }}>
                {renderSubTab()}
            </div>
        </div>
    );
};

export default FinanceiroTroco;
